import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header, Footer } from "@/components/kaje/Chrome";
import { Hero } from "@/components/kaje/Hero";
import { Marquee } from "@/components/kaje/Marquee";
import { Services } from "@/components/kaje/Services";
import { WideStrip } from "@/components/kaje/WideStrip";
import { Verification } from "@/components/kaje/Verification";
import { ContactForm } from "@/components/kaje/ContactForm";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo(0, 0);
    }
  }, [hash]);

  return (
    <div className="kaje-root bg-[#f8fafc] text-[#0f172a] antialiased min-h-screen" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <WideStrip />
        <Verification />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
